import React from 'react';
import { Navigate } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useAuth } from '../context/AuthContext';

// Legacy /dashboard bookmarks and old signup flows land here. Send users to
// the right place instead of rendering a placeholder page.
const Dashboard = () => {
  const { user, loading, isAdmin } = useAuth();

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 8 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (isAdmin) {
    return <Navigate to="/admin" replace />;
  }

  if (user?.role === 'vendor') {
    return <Navigate to="/vendor/dashboard" replace />;
  }

  return <Navigate to="/" replace />;
};

export default Dashboard;
